import { useState } from 'react';
import { OnSelectChange, Autocomplete, SelectSize, IconClose } from '@ui/src';
import InfoRow from '../info-row';
import { CountriesOfInterestTypes } from '../types';

import cn from '../new-application.module.css';

const RequiredCurrencies = ({
  value,
  setValue,
  setValuesList,
  index,
  values,
  list,
  disabled,
  title,
  error,
  clearErrors,
}: CountriesOfInterestTypes) => {
  const [errorVisible, setErrorVisible] = useState(false);

  const onChange = (e: OnSelectChange) => {
    if (!values.find((item) => item.id === e.target.value)) {
      const nextValues = values.map((item, valueIndex) => {
        const result = { ...item };

        if (index === valueIndex) {
          result.name = e.target.name;
          result.id = e.target.value as string;
        }

        return result;
      });

      setValue(
        'requiredCurrenciesCryptoId',
        nextValues.map((item) => item.id),
      );

      setValuesList(nextValues);
      setErrorVisible(false);
    } else {
      setErrorVisible(true);
    }
  };

  const deleteCurrency = (id: string) => {
    let nextValues;

    if (id) {
      nextValues = values.filter((item) => item.id !== id);
    } else {
      nextValues = values.filter((item, itemIndex) => index !== itemIndex);
    }

    setValue(
      'requiredCurrenciesCryptoId',
      nextValues.map((item) => item.id),
    );

    setValuesList(nextValues);
  };

  return (
    <InfoRow
      title={title}
      id="requiredCurrenciesCryptoId"
      borderless
      lessPadding
    >
      <>
        <div className={cn.sicCodeRow}>
          <Autocomplete
            name={`requiredCurrenciesCryptoId-${index}`}
            placeholder="Select currency"
            value={value.id}
            onChange={(e) => {
              onChange(e);
              clearErrors('requiredCurrenciesCryptoId');
            }}
            className={`${cn.newApplicationAutocomplete} ${
              disabled ? cn.newApplicationAutocompleteDisabled : ''
            }`}
            size={SelectSize.SMALL}
            list={list}
            disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            error={error}
            borderless
          />
          {!disabled && (
            <button
              type="button"
              className={cn.deleteSicCodeButton}
              onClick={() => deleteCurrency(value.id)}
              aria-label="Delete button"
              tabIndex={-1}
            >
              <IconClose width={15} height={15} />
            </button>
          )}
        </div>
        {errorVisible && (
          <div className={cn.sicCodesError}>Currencies must be unique</div>
        )}
      </>
    </InfoRow>
  );
};

export default RequiredCurrencies;
